import React from 'react';
import "./BlogPost.css";
import myt1 from '../../Assets/b61/myt1.jpg';
import myt2 from '../../Assets/b61/myt2.jpg';
import myt3 from '../../Assets/b61/myt3.jpg';
import myt4 from '../../Assets/b61/myt4.jpg';

function Blog61(){
  return (
    <>
      <div className='container-fluid my-5'>
        <div className='row mb-5'>
          <div className='col blog-text text-center'>
            <h1>Since 2012, the vision remains the same —to be the external IT team businesses can trust. 💻</h1>
            <h6>July 01, 2025 at 06:58 PM</h6>
          </div>
        </div>

        <div className='row align-items-center justify-content-center mx-5 gx-5 gy-5'>
          <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-5 col-xxl-5'>
            <div id="blogImages" className="carousel slide mx-auto" data-bs-ride="true" data-bs-interval='3000'>
              <div className="carousel-indicators">
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="1" aria-label="Slide 2"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="2" aria-label="Slide 3"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="3" aria-label="Slide 4"></button>
              </div>
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <img src={myt1} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={myt2} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={myt3} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={myt4} className="blog-img" alt="..."/>
                </div>
              </div>
              <button className="carousel-control-prev" type="button" data-bs-target="#blogImages" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button className="carousel-control-next" type="button" data-bs-target="#blogImages" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
          <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 blog-text'>
            <p>With integrity at our core, we provide real solutions.Built with purpose. Grown through impact.</p>
            <p>
            💡 100+ clients
            📊 150+ projects
            🌍 15+ industries
            🛠 15 proudly homegrown solutions
            👩‍🎓 Scholarships
            🎓 Internships
            </p>
            <p><a href='https://www.facebook.com/hashtag/mytsolutions' target='_blank' className='blog-link'>
              #MYTSolutions </a>
              <a href='https://www.facebook.com/hashtag/techforgood' target='_blank' className='blog-link'>
              #TechForGood</a>
              <a href='https://www.facebook.com/hashtag/buildtolast' target='_blank' className='blog-link'>
              #BuildToLast</a></p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Blog61;